import { useState, useEffect, SetStateAction } from 'react';

const useOrientation = () => {
  const [isLandscape, toggleIsLandscape] = useState(Math.abs(window.orientation) === 90);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: landscape)');
    toggleIsLandscape(mediaQuery.matches);

    const onOrientationChange = (m: { matches: SetStateAction<boolean>; }) => {
      toggleIsLandscape(m.matches);
    };

    mediaQuery.addListener(onOrientationChange);
    return () => {
      mediaQuery.removeListener(onOrientationChange);
    };
  }, []);

  return {
    isLandscape,
  };
};

export default useOrientation;
